export default function base64Conversion() {
  const before = `${process.env.REACT_APP_API_KEY}:${process.env.REACT_APP_API_PWD}`;
  const after = `Basic ${btoa(before)}`;
  return after;
}
